import { ChangeDetectorRef, inject } from '@angular/core';
import {
  AirportDropDown,
  AirportDropDownList,
  DestinationType,
  SearchableCity
} from '@com-delta-idp/mnx-sitewide-shared-core-ui';
import { MessageBanner, Search } from '@com-delta-omnichannel/mach-core-js';
import { FlightStatusFacadeService } from '../data-access/facades/flight-status.facade';
import { FlightStatusContainerHelperService } from '../data-access/services/flight-status-container-helper.service';

export abstract class FlightStatusContainerSuperBaseComponent {
  flightStatusFacade = inject(FlightStatusFacadeService);
  protected cdr = inject(ChangeDetectorRef);
  protected helper = inject(FlightStatusContainerHelperService);
  searchInstance!: Search;
  airportModalContent!: AirportDropDown;
  originAirport: AirportDropDownList = { code: '', name: '' };
  destinationAirport: AirportDropDownList = { code: '', name: '' };
  destinationType: DestinationType = '';
  openModalEvent = false;
  protected lastApiCall = '';
  protected isPrefilledValue = false;
  protected originAirportSearchResults: SearchableCity[] = [];
  protected destinationAirportSearchResults: SearchableCity[] = [];
  loaderContent = {
    label: 'Loading...'
  };

  showAlert = false;
  messageBanner!: MessageBanner;
  errorMessage = '';

  checkInvalidInput(searchText: string): boolean {
    const alphabetRegex = /^[a-zA-Z.\s]+$/;
    return !alphabetRegex.test(searchText);
  }

  protected swapAirportValues(): void {
    const temp = { ...this.originAirport };
    this.originAirport = { ...this.destinationAirport };
    this.destinationAirport = temp;

    const tempResults = this.originAirportSearchResults;
    this.originAirportSearchResults = this.destinationAirportSearchResults;
    this.destinationAirportSearchResults = tempResults;
  }
}
